import { Canvas, Edge, EdgeData, ElkRoot, NodeData } from "reaflow";
import { CustomLabel, CustomNode } from "../components/flow/components/graphs";
import { TaskStatus } from "../types";
import { getFlowTheme } from "../components/flow/theme";

import { useWorkflowProcessor } from "utils/useWorkflowProcessor";
import { MouseEvent, useRef } from "react";

const dashedEdgeStyles = {
  stroke: "#b1b1b7",
  strokeDasharray: "5",
  strokeDashoffset: 10,
  strokeWidth: 1,
  markerEnd: "none",
};

interface WorkflowVisualizerJsonProps {
  data: Record<string, unknown>; // The JSON input
  executionMode?: boolean; // The type input
  onClick?: (e: MouseEvent<HTMLElement>, data: NodeData) => void;
  subWorkflowFetcher?: () => Promise<any>;
  handleLayoutChange: (value: ElkRoot) => void;
}

function WorkflowVisualizerJson({
  data,
  executionMode = false,
  onClick,
  subWorkflowFetcher,
  handleLayoutChange,
}: // onClick,
WorkflowVisualizerJsonProps) {
  const canvasRef = useRef(null);
  const { nodes, edges } = useWorkflowProcessor(
    data,
    executionMode,
    subWorkflowFetcher
  );
  const theme = getFlowTheme("light");

  return (
    <Canvas
      ref={canvasRef}
      zoomable={false}
      pannable={false}
      animated={true}
      fit={false}
      nodes={nodes}
      edges={edges}
      layoutOptions={{
        "org.eclipse.elk.spacing.edgeEdge": "170",
        "org.eclipse.elk.padding": "[top=10,left=100,bottom=10,right=100]",
        "org.eclipse.elk.layered.edgeLabels.centerLabelPlacementStrategy":
          "SPACE_EFFICIENT_LAYER",
      }}
      edge={(edge: EdgeData) => {
        const edgeStylesForTaskStatus = [
          TaskStatus.COMPLETED,
          TaskStatus.COMPLETED_WITH_ERRORS,
        ].includes(edge?.data?.status)
          ? {
              stroke: theme.edges.completed.stroke,
              strokeWidth: theme.edges.completed.strokeWidth,
            }
          : {
              stroke: theme.edges.default.stroke,
              strokeWidth: theme.edges.default.strokeWidth,
            };
        const edgeStyles =
          edge?.data?.unreachableEdge === true
            ? dashedEdgeStyles
            : edgeStylesForTaskStatus;
        return (
          <Edge
            selectable={false}
            label={<CustomLabel nodes={nodes} selectEdge={() => null} />}
            style={edgeStyles}
          />
        );
      }}
      node={
        <CustomNode
          onClick={onClick}
          actions={null}
          onToggleTaskMenu={() => null}
          onDeleteBranch={() => null}
          isInconsistent={false}
        />
      }
      onLayoutChange={handleLayoutChange}
    />
  );
}

export default WorkflowVisualizerJson;
